import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { APP_DEFAULT_LANGUAGE_KEY } from 'config';

import en from './locales/en/translation.json';
import ru from './locales/ru/translation.json';

const resources = {
  en: {
    translation: en,
  },
  ru: {
    translation: ru,
  },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    resources,
    fallbackLng: APP_DEFAULT_LANGUAGE_KEY,
    lng: APP_DEFAULT_LANGUAGE_KEY,
    react: {
      useSuspense: false, //   <---- this will do the magic
    },
  });

export default i18n;
